<template>
  <div class="block">
      {{label}}
  </div>
</template>

<script>
export default {
  name: 'Block',
  props: {
      label: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    .block {
        width: 100%;
        background-color: red;
        min-height: 150px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 100;
        font-size: 32px;
        color: white;
    }
</style>
